import { useRouter } from "next/dist/client/router";
import React from "react";

const WaitForURLQuery = ({ Component }) => {
  const { query = {} } = useRouter();

  if (Object.keys(query).length) {
    return <Component {...query} />;
  }
  return "Loading...";
};

export { WaitForURLQuery };
